<div class="nav">
  <div class="nav_container_titlePage">
    {{title}}
  </div>
  <div class="parameters_connect">
    <div class="connect">
      <div class='online' *ngIf="isConnect"></div>
      <div class='offline' *ngIf="!isConnect"></div>
      <fa-icon [icon]="faUser" [routerLink]="['/profil']" routerLinkActive="router-link-active"></fa-icon>
    </div>
    <div class="parameters" [routerLink]="['/parametres']" routerLinkActive="router-link-active"
      *ngIf="router.url != '[/home/paramatres]' && isConnect ">
      <img src="assets/img/icon-white/parametres.svg" alt="paramatres">
    </div>
    <!-- <div class="localisation" (click)="iWantToGeoOrNot()">
        <img [src]="isGeo? 'assets/img/icon-white/localisation_on.png': 'assets/img/icon-white/localisation_off.svg'"
          alt="localisation">
      </div> -->
  </div>
</div>